import * as React from 'react';

import { useRetracked } from 'js/lib/retracked';
import { useLocation } from 'js/lib/useRouter';

import type { DiscoveryCollection } from 'bundles/browse/components/types/DiscoveryCollections';
import AutoComplete from 'bundles/search-common/components/searchbar/AutoComplete';
import type { SearchBarLocation } from 'bundles/search-common/constants';
import { AUTOCOMPLETE_SEARCH_CONFIG } from 'bundles/search-common/constants/autocomplete';
import SearchProvider from 'bundles/search-common/providers/SearchProvider';
import { inferQueryFromParams } from 'bundles/search-common/utils/eventingUtils';

import 'css!./__styles__/AutoComplete';

export type Props = {
  isSearchPage: boolean;
  pageLocation?: SearchBarLocation;
  searchIsOpen?: boolean;
  collectionRecommendations?: DiscoveryCollection | null;
  shouldFocusSearch?: boolean;
  onSearchFocus?: () => void;
  hideMobileSearchPage?: () => void;
  enableOneStepSearch?: boolean;
  shouldShowExposedSearchAndReg?: boolean;
  startingQuery?: string;
};

const AutoCompleteWrapper = (props: Props) => {
  const track = useRetracked();
  const location = useLocation();
  const queryFromUrl = inferQueryFromParams(location.query?.query || '');

  return (
    <SearchProvider searchConfigs={AUTOCOMPLETE_SEARCH_CONFIG}>
      <AutoComplete track={track} query={queryFromUrl || props.startingQuery || ''} {...props} />
    </SearchProvider>
  );
};

export default AutoCompleteWrapper;
